import { CustomElement } from '@aurelia/runtime-html';
export const name = "progress-bar-component";
export const template = "<!-- <div id=\"${barId}\" class=\"w-full h-2\"></div> -->\n\n<div id=\"${barId}\" class=\"w-full ${barHeight} rounded-full overflow-hidden\"></div>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
